import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ImageComponent, LoadingContainerComponent } from 'common-ui';
import { ErrorComponent } from 'error-ui';
import { ProductComponentBase } from '../../../ProductComponentBase';

@Component({
  selector: 'ideal-product-badges',
  imports: [LoadingContainerComponent, MatButtonModule, ImageComponent, ErrorComponent],
  templateUrl: './product-badges.component.html',
  styleUrls: ['./product-badges.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.loading]': 'loading()',
    '[class.no-content]': '!hasContent()',
    '[style.display]': 'badges.loading() ? null : (this.badgeItems().length > 0 ? null : "none")',
  },
})
export class ProductBadgesComponent extends ProductComponentBase {
  protected readonly badges = this.productStore.productBadges;
  protected readonly badgeItems = computed(() => this.productStore.productBadges()?.badges ?? []);
  protected readonly ready = computed(() => !this.badges.error() && !this.badges.loading() && !!this.badges());

  protected override computeIsLoading = () => this.badges.loading;
  protected override computeHasContent = () => computed(() => !!this.badges.error() || this.badgeItems().length > 0);
}
